import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded'
import { Box, Button, styled } from '@mui/material'
import {
  Children,
  forwardRef,
  ReactNode,
  Ref,
  useCallback,
  useImperativeHandle,
  useState
} from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Swiper as SwiperType } from 'swiper/types'

const StyledSwiper = styled(Swiper)`
  background-color: transparent;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  left: 0;
  right: 0;
`

const StyledSwiperSlide = styled(SwiperSlide)`
  aspect-ratio: 1;
  border-radius: 5px;
  cursor: pointer;
  position: relative;
  &.swiper-slide {
    width: 100vw;
    height: auto;
  }
`

const PreviousButton = styled(Button)`
  position: absolute;
  transform-origin: center;
  ${props => props.theme.breakpoints.between('res480', 'res768')} {
    top: 240px;
    left: calc(50% - 210px);
    right: unset;
  }
  ${props => props.theme.breakpoints.down('res480')} {
    top: 280px;
    left: calc(5%);
    right: unset;
  }
`

const NextButton = styled(PreviousButton)`
  transform: scaleX(-1);
  ${props => props.theme.breakpoints.between('res480', 'res768')} {
    left: unset;
    right: calc(50% - 200px);
  }
  ${props => props.theme.breakpoints.down('res480')} {
    left: unset;
    right: calc(5%);
  }
`

const Arrow = styled(ArrowBackIosNewRoundedIcon)`
  color: #d9d9d9;
  ${props => props.theme.breakpoints.between('res480', 'res768')} {
    font-size: 80px;
  }
  ${props => props.theme.breakpoints.down('res480')} {
    font-size: 40px;
  }
`

const MobilePlanetSwiper = forwardRef(function _(
  { children, className }: Props,
  ref: Ref<MobilePlanetSwiperRefHandle>
) {
  const [swiper, setSwiper] = useState<SwiperType>()

  const handleOnNext = useCallback(() => {
    if (swiper) {
      swiper.slideNext()
    }
  }, [swiper])

  const handleOnPrevious = useCallback(() => {
    if (swiper) {
      swiper.slidePrev()
    }
  }, [swiper])

  useImperativeHandle(
    ref,
    () => {
      return {
        slideTo(index: number) {
          swiper?.slideToLoop(index, 0)
        }
      }
    },
    [swiper]
  )

  return (
    <Box className={className}>
      <StyledSwiper
        autoplay={false}
        className={'Custom-Swiper'}
        effect='slide'
        loop={Children.count(children) > 1}
        slidesPerView={1}
        onSwiper={(swiper: SwiperType) => setSwiper(swiper)}
      >
        {children}
      </StyledSwiper>
      {Children.count(children) > 1 && (
        <>
          <PreviousButton className={'Custom-Previous-Button'}>
            <Arrow onClick={handleOnPrevious} />
          </PreviousButton>
          <NextButton className={'Custom-Next-Button'}>
            <Arrow onClick={handleOnNext} />
          </NextButton>
        </>
      )}
    </Box>
  )
})

type Props = {
  children: ReactNode
  className?: string
}

export { StyledSwiperSlide as MobilePlanetSwiperSlide }

export type MobilePlanetSwiperRefHandle = { slideTo: (index: number) => void }

export default MobilePlanetSwiper
